import requestAction from '../../utils/requestAction'

export const fetchAssignations = (params: string, prefix = '') =>
  requestAction('ASSIGNATION_LIST', params)(`${prefix}assignations`, 'GET')

export const fetchReferencesAssignations = (params: string) => fetchAssignations(params, 'references/')

